(function () {
  function applyHestiaSoundGestureFix() {
    if (typeof VideoCarousel === "undefined") return false;
    if (VideoCarousel.prototype.__hestiaSoundGestureFix) return true;

    var proto = VideoCarousel.prototype;
    var originalPlay = proto.playVideoInline;

    proto.playVideoInline = function (item, isAutoplay) {
      if (typeof isAutoplay === "undefined") isAutoplay = false;
      var result = originalPlay.call(this, item, isAutoplay);

      // originalPlay forces muted then defers unmute via setTimeout — outside the
      // user-activation window, so browsers keep playback silent. Unmute + play
      // synchronously here while we still have the click gesture.
      if (!isAutoplay) {
        var vc = item.querySelector(".inline-video-container");
        if (vc) {
          var video = vc.querySelector("video");
          if (video) {
            video.muted = false;
            video.removeAttribute("muted");
            try {
              video.volume = 1;
            } catch (e) {}
            var p = video.play();
            if (p && typeof p.catch === "function") p.catch(function () {});
          }
          var typeEl = item.querySelector(".video-type");
          var type = typeEl && typeEl.dataset ? typeEl.dataset.type : "shopify";
          if (typeof this.unmuteVideo === "function") {
            this.unmuteVideo(type, vc);
          }
        }
      }
      return result;
    };

    var originalResume = proto.resumeVideo;
    proto.resumeVideo = function (item) {
      var result = originalResume.call(this, item);
      var vc = item.querySelector(".inline-video-container");
      if (vc) {
        var video = vc.querySelector("video");
        if (video) {
          video.muted = false;
          video.removeAttribute("muted");
          try {
            video.volume = 1;
          } catch (e) {}
        }
        var typeEl = item.querySelector(".video-type");
        var type = typeEl && typeEl.dataset ? typeEl.dataset.type : "shopify";
        if (typeof this.unmuteVideo === "function") {
          this.unmuteVideo(type, vc);
        }
      }
      return result;
    };

    VideoCarousel.prototype.__hestiaSoundGestureFix = true;
    return true;
  }

  function boot() {
    if (applyHestiaSoundGestureFix()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (applyHestiaSoundGestureFix() || tries > 40) clearInterval(timer);
    }, 50);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
